// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.continuum-accordion {
  background-color: white;
}

.continuum-accordion--header {
  box-shadow: 0px 12px 32px rgba(12, 0, 51, 0.1);
  border: 1px solid #DBDBDB;
  border-left: 8px solid black;
}

.Risk .continuum-accordion--header {
  border-left: 8px solid #00A908;
}

.Disease .continuum-accordion--header {
  border-left: 8px solid #F5821F;
}

.Death .continuum-accordion--header {
  border-left: 8px solid #B81237;
}

.continuum-accordion--toggle,
.continuum-accordion--header,
.continuum-accordion--message {
  padding-left: 24px;
  padding-right: 24px;

}

.continuum-accordion--toggle,
.continuum-accordion--message {
  margin-left: -24px;
  margin-right: -24px;
  line-height: 48px;
  border-top: 1px solid #C5C5C5;
}
.continuum-accordion--toggle {
  cursor: pointer;
}

.continuum-accordion--toggle i {
  transition: transform 300ms;
}
.continuum-accordion--toggle i.rotate {
  transform: rotate(180deg);
  transition: transform 300ms;
}

.continuum-accordion--toggle:hover {
  background-color: rgba(0,171,230,.2)
}

.continuum-accordion--toggle > span {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.continuum-accordion--message {
  color: #333333;
  text-align: right;
}

.continuum-accordion--content {
  width: calc(100% - 24px);
  min-height: 16px;
  border-left: 4px solid #E4E4E6;
  margin-left: 24px;
  margin-right: 24px;
}

@media (min-width: 768px) {
  .continuum-accordion--content {
    max-width: calc(11 / 12 * 100%  - 24px);
  }
}

@media (min-width: 992px) {
  .continuum-accordion--content {
    max-width: calc(9/12 * 100% - 24px);
  }
}

.continuum-accordion--content-container {
  padding-bottom: 5rem;
}

.continuum-accordion--content-container > h4 {
  padding-left: 16px;
}

.continuum-accordion.death {
  margin-bottom: 3rem;
}

.continuum-accordion .link-list__list {

}

.continuum-accordion .link-list__item {
  width: 100%;
  /* margin-left: -24px;
  padding-left: 8px; */
}

.continuum-accordion .link-list__item {
  border-bottom: none;
  border-top: 1px solid #E4E4E6;
}

.continuum-accordion--content-container > ul > li.link-list__item:last-child {
  border-bottom: 1px solid #E4E4E6;
}

.continuum-accordion ul li li a{
  padding-left: calc(1/12 * 100%);
}

.continuum-accordion ul li li li a{
  padding-left: calc(2/12 * 100%);
}

.continuum-accordion ul li li li li a{
  padding-left: calc(3/12 * 100%);
}

continuum-accordion:last-child .continuum-accordion--content {
  min-height: 0;
}

continuum-accordion:last-child .continuum-accordion--content-container
{
  padding-bottom: 0;
}

.compact-title {
  margin-bottom: 0;
  padding-top: 1.25rem;
}

.compact-subtitle {
  padding-top: 0;
  margin-bottom: 1.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/uilib/continuum-accordion/continuum-accordion.component.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,8CAA8C;EAC9C,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;EAGE,kBAAkB;EAClB,mBAAmB;;AAErB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,mCAAmC;EACrC;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;AAEA;;AAEA;EACE,WAAW;EACX;sBACoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB","sourcesContent":[".continuum-accordion {\r\n  background-color: white;\r\n}\r\n\r\n.continuum-accordion--header {\r\n  box-shadow: 0px 12px 32px rgba(12, 0, 51, 0.1);\r\n  border: 1px solid #DBDBDB;\r\n  border-left: 8px solid black;\r\n}\r\n\r\n.Risk .continuum-accordion--header {\r\n  border-left: 8px solid #00A908;\r\n}\r\n\r\n.Disease .continuum-accordion--header {\r\n  border-left: 8px solid #F5821F;\r\n}\r\n\r\n.Death .continuum-accordion--header {\r\n  border-left: 8px solid #B81237;\r\n}\r\n\r\n.continuum-accordion--toggle,\r\n.continuum-accordion--header,\r\n.continuum-accordion--message {\r\n  padding-left: 24px;\r\n  padding-right: 24px;\r\n\r\n}\r\n\r\n.continuum-accordion--toggle,\r\n.continuum-accordion--message {\r\n  margin-left: -24px;\r\n  margin-right: -24px;\r\n  line-height: 48px;\r\n  border-top: 1px solid #C5C5C5;\r\n}\r\n.continuum-accordion--toggle {\r\n  cursor: pointer;\r\n}\r\n\r\n.continuum-accordion--toggle i {\r\n  transition: transform 300ms;\r\n}\r\n.continuum-accordion--toggle i.rotate {\r\n  transform: rotate(180deg);\r\n  transition: transform 300ms;\r\n}\r\n\r\n.continuum-accordion--toggle:hover {\r\n  background-color: rgba(0,171,230,.2)\r\n}\r\n\r\n.continuum-accordion--toggle > span {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.continuum-accordion--message {\r\n  color: #333333;\r\n  text-align: right;\r\n}\r\n\r\n.continuum-accordion--content {\r\n  width: calc(100% - 24px);\r\n  min-height: 16px;\r\n  border-left: 4px solid #E4E4E6;\r\n  margin-left: 24px;\r\n  margin-right: 24px;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .continuum-accordion--content {\r\n    max-width: calc(11 / 12 * 100%  - 24px);\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .continuum-accordion--content {\r\n    max-width: calc(9/12 * 100% - 24px);\r\n  }\r\n}\r\n\r\n.continuum-accordion--content-container {\r\n  padding-bottom: 5rem;\r\n}\r\n\r\n.continuum-accordion--content-container > h4 {\r\n  padding-left: 16px;\r\n}\r\n\r\n.continuum-accordion.death {\r\n  margin-bottom: 3rem;\r\n}\r\n\r\n.continuum-accordion .link-list__list {\r\n\r\n}\r\n\r\n.continuum-accordion .link-list__item {\r\n  width: 100%;\r\n  /* margin-left: -24px;\r\n  padding-left: 8px; */\r\n}\r\n\r\n.continuum-accordion .link-list__item {\r\n  border-bottom: none;\r\n  border-top: 1px solid #E4E4E6;\r\n}\r\n\r\n.continuum-accordion--content-container > ul > li.link-list__item:last-child {\r\n  border-bottom: 1px solid #E4E4E6;\r\n}\r\n\r\n.continuum-accordion ul li li a{\r\n  padding-left: calc(1/12 * 100%);\r\n}\r\n\r\n.continuum-accordion ul li li li a{\r\n  padding-left: calc(2/12 * 100%);\r\n}\r\n\r\n.continuum-accordion ul li li li li a{\r\n  padding-left: calc(3/12 * 100%);\r\n}\r\n\r\ncontinuum-accordion:last-child .continuum-accordion--content {\r\n  min-height: 0;\r\n}\r\n\r\ncontinuum-accordion:last-child .continuum-accordion--content-container\r\n{\r\n  padding-bottom: 0;\r\n}\r\n\r\n.compact-title {\r\n  margin-bottom: 0;\r\n  padding-top: 1.25rem;\r\n}\r\n\r\n.compact-subtitle {\r\n  padding-top: 0;\r\n  margin-bottom: 1.25rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
